import { ECardinality, EScreenType, ESdChangeReason, IAction, IActionParameter, ISymbol } from "@kuika/kuika-cl-model";
import _ from "lodash";
import React from "react";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { IActionPanelStatesCanBeUpdatedFromChild } from "./action-panel";
import ActionParameterTitle from "./action-parameter-title";
import { SymbolPicker } from "./symbol-picker";

export interface IUpdateUserStartingScreenSymbolsGroupProps {
  action?: IAction;
  parameters: IActionParameter[];
  updateValues: (value: IActionPanelStatesCanBeUpdatedFromChild, changeReason?: ESdChangeReason) => void;
}

export interface IUpdateUserStartingScreenSymbolsGroupState {}

class UpdateUserStartingScreenSymbolsGroup extends React.PureComponent<
  IUpdateUserStartingScreenSymbolsGroupProps & IWithSDProps,
  IUpdateUserStartingScreenSymbolsGroupState
> {
  constructor(props: IUpdateUserStartingScreenSymbolsGroupProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  getParameterWithName = (name: "userName" | "startingScreenId"): IActionParameter | undefined => {
    return this.props.parameters.find((x) => x.name === name);
  };

  getStartingScreenSelectValue = () => {
    const toScreenId = this.getParameterWithName("startingScreenId");
    if (toScreenId?.symbol?.fixedValue && toScreenId.symbol.fixedValue !== "") return toScreenId.symbol.fixedValue;
    return "";
  };

  onSelectToScreen = (val: string, check?: boolean): void => {
    const parameters = [...this.props.parameters];
    const startingScreenIdParameter = this.getParameterWithName("startingScreenId");
    if (startingScreenIdParameter) {
      startingScreenIdParameter.symbol.fixedValue = val;
      this.props.updateValues({ actionParameters: parameters });
    }
  };

  handleSelectSymbolPickerValue = (parameter: IActionParameter, symbol: ISymbol, changeReason?: ESdChangeReason) => {
    const params = _.cloneDeep(this.props.parameters);
    const _parameter = parameter;
    _parameter.symbol = symbol;
    const valuesToUpdate = {
      actionParameters: params
    } as IActionPanelStatesCanBeUpdatedFromChild;
    valuesToUpdate.actionParameters?.push(_parameter);
    this.props.updateValues(valuesToUpdate, changeReason);
  };

  renderUserName = () => {
    const message = this.getParameterWithName("userName");

    return (
      <div>
        <div style={{ marginTop: 12 }} className="kuika_add_actions_properties_name">
          <ActionParameterTitle parameter={{ name: "Username", Typename: "String", cardinality: ECardinality.One }} />
        </div>
        <SymbolPicker
          action={this.props.action}
          changeType="onBlur"
          symbol={message!.symbol}
          valueType={"String"}
          targetCardinality={message!.cardinality}
          onSelectedSymbol={(symbol: ISymbol, changeReason?: ESdChangeReason) =>
            this.handleSelectSymbolPickerValue(message!, symbol, changeReason)
          }
          bindingParameter={message}
          bindingLabel="Username"
        />
      </div>
    );
  };

  renderToStartingScreenId = () => {
    const parameters = [...this.props.parameters];
    let targetScreenId = "";
    const toScreenParameter = parameters.find((x) => x.name === "toScreenId");
    if (toScreenParameter) {
      targetScreenId = toScreenParameter.symbol.fixedValue;
    }
    const processStepScreens = this.props.sd.screenList?.filter((screen) =>
      this.props.sd.project.processStepScreenIds?.find((process) => screen.id === process.screenId.toString())
    );

    const screenOptions: KuikaSelectboxOption[] =
      this.props.sd.screenList
        ?.sort((a, b) => a.name.localeCompare(b.name))
        ?.filter((x) => x.publicMetaData.screenType !== EScreenType.Report)
        ?.filter((x) => x.publicMetaData.screenType !== EScreenType.Master)
        ?.filter((x) => x.publicMetaData.screenType !== EScreenType.Component)
        ?.filter((x) => x.id !== processStepScreens?.find((p) => p.id === x.id)?.id)
        ?.map((s): KuikaSelectboxOption => ({ key: s.id, value: s.id, label: s.name })) ?? [];

    return (
      <div>
        <div style={{ marginTop: 12 }} className="kuika_add_actions_properties_name">
          Starting Screen
        </div>
        <div className="kuika_property-grid-column">
          <KuikaSelectbox
            searchable
            size="sm"
            style={{ width: "100%" }}
            value={this.getStartingScreenSelectValue()}
            onChange={(value: string): void => this.onSelectToScreen(value, false)}
            className="kuika_add_actions_inputs_size"
            options={screenOptions}
          />
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.renderUserName()}
        {this.renderToStartingScreenId()}
      </div>
    );
  }
}

const updateUserStartingScreenSymbolsGroup = withSD<IUpdateUserStartingScreenSymbolsGroupProps>(
  UpdateUserStartingScreenSymbolsGroup
);
export { updateUserStartingScreenSymbolsGroup as UpdateUserStartingScreenSymbolsGroup };
